// import axios from 'axios';

// export default function customFetch(url, options) {
//   // return a promise of axios
//   return axios(url, options);
// }
import axios from 'axios';
import cookie from 'react-cookie';
import {store} from 'base/reducers';

export default function customFetch(url, options) {
  // return a promise of axios
  let at = cookie.load('accessToken');
  if (at) {
    axios.defaults.headers.common['Authorization'] = `${at}`;
  }

  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (401 === error.response.status && cookie.load('accessToken')) {
      // Force logout
      cookie.remove('accessToken', {path: '/'});

      window.location.href = "/signin";

    } else {
      return Promise.reject(error);
    }

    return Promise.reject(error);
  });

  return new Promise((resolve, reject) => {
    axios(url, options).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}



// WEBPACK FOOTER //
// ./api/axios.js